/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import ReactDOM from 'react-dom';
import LiveBlog from './liveblog';
import MainStage from './stage';
import config from './config.json';

$(() => {
  $('#liveblog-container').each((i, element) => {
    const apiEndpoint = $(element).attr('data-endpoint') || config.apiEndpoint;
    const pollInterval = $(element).attr('data-poll') !== undefined
      ? Number($(element).attr('data-poll')) : config.pollInterval;
    ReactDOM.render(<LiveBlog apiEndpoint={apiEndpoint} pollInterval={pollInterval} />, element);
  });

  if ($('#main-stage').length) {
    const mainStage = new MainStage($('#main-stage').first());
    if (window.IDM314 === undefined) {
      window.IDM314 = {};
    }

    window.IDM314.mainStage = mainStage;
  }
});
